import React from 'react';
import { UserCheck } from 'lucide-react';

const WhoThrives = () => {
  return (
    <section className="py-24 bg-slate-900 text-white text-center">
      <div className="max-w-3xl mx-auto px-6">
        <UserCheck className="w-12 h-12 mx-auto mb-6 text-slate-400" />
        <h2 className="text-3xl font-bold mb-8">Who Thrives Here</h2>
        <p className="text-xl text-slate-300 mb-12 leading-relaxed">
          InternStacks is built for individuals who want exposure to structured development cycles, accept review and accountability, value contribution over certificates, and seek to build a documented technical footprint.
        </p>
        <div className="p-6 border border-slate-700 bg-slate-800/50 inline-block rounded-sm">
          <p className="text-lg font-medium text-emerald-400">This ecosystem rewards seriousness.</p>
        </div>
      </div>
    </section>
  );
};

export default WhoThrives;
